import { useLazyQuery } from "@apollo/client";
import { useAppDispatch, useAppSelector } from "../../../redux/hook";
import { bankingClient } from "../../../apolloClient";
import { useEffect, useCallback } from "react";
import { _myInformation, MyInformationItem } from "../../../indexDB/data";
import { BANKING_INFO } from "../../../graphql/graphql_banking/legder/query";
import { setMyAccount } from "../../../redux/ledger/ledgerSlice";
import {
  BankingInfo,
  BankingInfoVariables,
} from "../../../graphql/graphql_banking/legder/types/BankingInfo";
import { AccountBankingInfo } from "../../../graphql/graphql_banking/legder/types/AccountBankingInfo";

const useMyAccount = (synchronize?: boolean) => {
  const dispatch = useAppDispatch();

  const accountUsed = useAppSelector(
    (state) => state.information.myInformation.connected?.accountUsed,
  );
  const { allAccount } = useAppSelector((state) => state.ledger);

  const setData = useCallback(
    async (data: AccountBankingInfo) => {
      dispatch(setMyAccount(data));
    },
    [dispatch],
  );

  const [getAccount, { loading, data }] = useLazyQuery<
    BankingInfo,
    BankingInfoVariables
  >(BANKING_INFO, {
    fetchPolicy: "no-cache",
    client: bankingClient,
    onCompleted: async (data) => {
      if (data?.bankingInfo) {
        await _myInformation.setItem(
          MyInformationItem.MY_LEDGER,
          data.bankingInfo,
        );
        await setData(data.bankingInfo);
      }
    },
  });

  const fetchLedgerData = useCallback(
    async (paynovateId: number) => {
      const cache = await _myInformation.getItem(MyInformationItem.MY_LEDGER);
      if (cache && !synchronize) {
        await setData(cache as AccountBankingInfo);
      } else {
        getAccount({ variables: { paynovateId } });
      }
    },
    [getAccount, setData, synchronize],
  );

  useEffect(() => {
    const paynovateId = accountUsed || allAccount?.[0]?.paynovateId;
    if (paynovateId) {
      fetchLedgerData(paynovateId);
    }
  }, [accountUsed, allAccount, fetchLedgerData]);

  return { getAccount, loading, data };
};

export default useMyAccount;
